import { atom, useAtomValue, useSetAtom } from 'jotai'

/**
 * Active brief context, set by BriefTab on mount when a brief is ready.
 * Read by the sidepanel chat input to route follow-up messages back into
 * the brief's conversationId so the user can continue that agentic chat.
 *
 * Cleared on unmount (Tabs.Panel unmounts inactive tabs in base-ui by
 * default, so switching tabs naturally clears this).
 */
const activeBriefContextAtom = atom<{ calendarEventId: string; conversationId: string } | null>(null)

export function useActiveBriefContext() {
  return useAtomValue(activeBriefContextAtom)
}

export function useSetActiveBriefContext() {
  return useSetAtom(activeBriefContextAtom)
}
